export default {
    props: [
        'position',
        'zindex',
        'size',
        'showMessage',
        'visible'
    ]
}
